export default [
  {
    group: 'liquid',
    links: [
      {
        label: 'about',
        href: 'aboutUs',
      },
      // {
      //   label: 'careers',
      //   href: 'careers',
      // },
    ],
  },
  {
    group: 'legalAndPrivacy',
    links: [
      {
        label: 'termOfUse',
        type: 'term-and-condition',
        href: 'termOfUse',
      },
      {
        label: 'privacyPolicy',
        type: 'privacy-policy',
        href: 'privacyPolicy',
      },
      {
        label: 'riskDisclosure',
        type: 'risks',
        href: 'riskDisclosure',
      },
      {
        label: 'tradingRules',
        type: 'trading-rules',
        href: 'tradingRules',
      },
      {
        label: 'security',
        href: 'security',
      },
      // {
      //   label: 'perpetual',
      //   href: 'perpetual',
      // },
      {
        label: 'status',
        href: 'status',
      },
    ],
  },
  {
    group: 'service',
    links: [
      // {
      //   label: 'liquidPro',
      //   href: 'pro',
      // },
      {
        label: 'listings',
        href: 'listings',
      },
      {
        label: 'fees',
        href: 'fees',
      },
      {
        label: 'referrals',
        href: 'referrals',
      },
      // {
      //   label: 'paymentLicense',
      //   href: 'paymentLicense',
      // },
    ],
  },
  {
    group: 'support',
    links: [
      {
        label: 'apiDocs',
        href: 'apiDocs',
      },
      {
        label: 'contactUs',
        href: 'contactUsForm',
      },
    ],
  },
  // {
  //   group: 'features',
  //   links: [
  //     {
  //       label: 'liquid',
  //       href: 'market',
  //     },
  //     {
  //       label: 'buyAndSwap',
  //       href: 'quickExchange',
  //     },
  //   ],
  // },

  // {
  //   group: 'learn',
  //   links: [
  //     {
  //       label: 'blog',
  //       href: 'blog',
  //     },
  //     {
  //       label: 'contactSupport',
  //       href: 'support',
  //     },
  //   ],
  // },

  // {
  //   group: 'company',
  //   links: [
  //     {
  //       label: 'contactUs',
  //       href: 'contactUsForm',
  //     },
  //   ],
  // },
];



// WEBPACK FOOTER //
// ../src/components/Footer/Navigation/enData.js